import { getItem, removeItem, setItem } from './localStorage';

export const EUNPYEONG_CARE_COUPON_CODE = 'EUNPYEONGCARE';

const EP_LOCAL_STORAGE_KEY = 'EP_LOCAL_COUPON';

export const epLocalStorageHandler = (method: 'GET' | 'SET' | 'DELETE', coupon?: string) => {
  if (method === 'SET' && coupon) {
    setItem(EP_LOCAL_STORAGE_KEY, coupon);
  }
  if (method === 'DELETE') {
    removeItem(EP_LOCAL_STORAGE_KEY);
  }
  return getItem(EP_LOCAL_STORAGE_KEY);
};
